module.exports = __webpack_public_path__ + "img/cont-09-consumo.31fe2d3e.svg";